<template>
    <v-btn
        v-bind="$attrs"
        :color="props.disabled ? 'aquassistGray1' : props.color"
        :disabled="props.disabled"
        :loading="props.loading"
        :prepend-icon="props.prependIcon"
        :size="props.size"
        :variant="props.variant"
        :height="props.height"
        :icon="!!props.icon"
        :border="props.border"
    >
        <template v-if="props.icon">
            <AQIcon :name="props.icon" :size="iconSize" />
        </template>
        <template v-else>
            <slot />
        </template>
    </v-btn>
</template>

<script setup lang="ts">
    import AQIcon from '@/components/shared/interactions/AQIcon.vue';
    const props = defineProps<{
        primary?: boolean;
        outlined?: boolean;
        basic?: boolean;
        color?: string;
        disabled?: boolean;
        loading?: boolean;
        prependIcon?: string;
        size?: 'x-small' | 'small' | 'default' | 'large' | 'x-large' | number;
        icon?: string;
        iconSize?: 'x-small' | 'small' | 'default' | 'large' | 'x-large' | number;
        variant?: 'text' | 'flat' | 'elevated' | 'tonal' | 'outlined' | 'plain';
        height?: string | number;
        border?: string | number;
    }>();
</script>
